import { useContext } from "react";
import { IRapportWebPackage } from "./i18n-webview";
import I18nContext from "./i18n-context";

export const useTranslation = (rapportPackage?: IRapportWebPackage) => {
  const { i18n, locale } = useContext(I18nContext);
  if (rapportPackage) {
    i18n.extend(rapportPackage);
  }
  return {
    _translate: i18n._translate.bind(i18n.instance),
    _t: i18n._t.bind(i18n.instance),
    _abbr: i18n._abbr.bind(i18n.instance),
    _abbreviation: i18n._abbr.bind(i18n.instance),
    locale
  };
};

export default useTranslation;
